<template>
  <div id="user-modal">
    <div class="input-part">
      <div class="error-messages-modal-part" v-if="errorMessage">
        <ul>
          <li class="error-message">
            {{ errorMessage }}
          </li>
        </ul>
      </div>
      <div class="full-name-wrapper">
        <basic-input
          width="100%"
          :placeholder="$t('usersScreen.userModal.form.fullName')"
          :label="$t('usersScreen.userModal.form.fullName')"
          class="full-name"
          v-model="inputs.fullName"
        />
      </div>
      <div class="username-wrapper">
        <basic-input
          width="100%"
          :placeholder="$t('usersScreen.userModal.form.username')"
          :label="$t('usersScreen.userModal.form.username')"
          class="username"
          v-model="inputs.username"
        />
      </div>
      <div class="password-wrapper">
        <basic-input
          width="100%"
          :placeholder="$t('usersScreen.userModal.form.password')"
          :label="$t('usersScreen.userModal.form.password')"
          class="password"
          type="password"
          v-model="inputs.password"
        />
      </div>
      <div class="roles-wrapper" @click.stop>
        <basic-select
          :placeholderText="$t('usersScreen.userModal.form.roles')"
          :label="$t('usersScreen.userModal.form.roles')"
          class="role"
          ref="select"
          v-model="inputs.role"
        >
          <basic-select-item
            v-if="getActiveUser.role === $variables.roleName.ADMIN"
            :value="2"
            :text="$t($variables.roles[2])"
          />
          <basic-select-item :value="1" :text="$t($variables.roles[1])" />
          <basic-select-item :value="0" :text="$t($variables.roles[0])" />
        </basic-select>
      </div>
    </div>
    <div class="footer">
      <rounded-button
        :disabled="!isButtonValid"
        position="right"
        width="150px"
        @click="saveButtonClicked"
      >
        {{ $t("usersScreen.userModal.saveButton") }}
      </rounded-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "UserModal",
  props: {
    user: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      errorMessage: undefined,
      inputs: {
        fullName: this.user ? this.user.fullName : undefined,
        username: this.user ? this.user.username : undefined,
        password: undefined,
        role: this.user ? this.user.role : undefined
      },
      needUpload: false,
      image: undefined
    };
  },
  methods: {
    ...mapActions({
      createUser: "user/createUser",
      updateUser: "user/updateUser"
    }),
    roleChanged(payload) {
      this.inputs.role = payload.value;
    },
    saveButtonClicked() {
      if (this.user) {
        this.updateUser({ id: this.user.id, body: this.formData }).then(res => {
          if (res.status === "OK") {
            this.$eventBus.closeModal();
            this.$eventBus.initPageData();
            this.showNoti();
          } else {
            this.errorMessage = res.errorMessage;
          }
        });
      } else {
        this.createUser(this.formData).then(res => {
          if (res.status === "OK") {
            this.$eventBus.closeModal();
            this.$eventBus.initPageData();
            this.showNoti();
          } else {
            this.errorMessage = res.errorMessage;
          }
        });
      }
    },
    showNoti() {
      const title = this.user
        ? "usersScreen.editUserNoti.title"
        : "usersScreen.createUserNoti.title";
      const text = this.user
        ? "usersScreen.editUserNoti.success.text"
        : "usersScreen.createUserNoti.success.text";
      this.$eventBus.showDropdownNoti({
        icon: "success",
        title: this.$t(title),
        text: this.$t(text)
      });
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: "user/getActiveUser"
    }),
    formData() {
      // const formData = new FormData();
      const formData = {};
      if (this.inputs.fullName) formData.fullName = this.inputs.fullName;
      // formData.append("fullName", this.inputs.fullName);
      if (this.inputs.username) formData.username = this.inputs.username;
      // formData.append("username", this.inputs.username);
      if (this.inputs.password) formData.password = this.inputs.password;
      // formData.append("password", this.inputs.password);
      if (this.inputs.role !== undefined || this.inputs.role !== null)
        formData.role = this.inputs.role;
      // formData.append("role", this.inputs.role);
      // if (this.image) formData.append("image", this.image);
      return formData;
    },
    isButtonValid() {
      return (
        this.user ||
        (this.inputs.fullName &&
          this.inputs.username &&
          this.inputs.password &&
          this.inputs.role !== undefined)
      );
    }
  }
};
</script>
<style lang="scss" scoped>
#user-modal {
  padding: 10px;
  .input-part {
    .full-name-wrapper {
      margin-bottom: 10px;
    }
    .username-wrapper {
      margin-bottom: 10px;
    }
    .password-wrapper {
      margin-bottom: 10px;
    }
    .roles-wrapper {
      margin-bottom: 30px;
    }
  }
}
</style>
